module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-bold-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-bold-webfont.woff
// module id = 92
// module chunks = d-game